<template>
  <div class="wrapp-order-result">
    <template v-if="searchResponse">
      <div class="wrapp-totals">
        <span class="text">{{$t('totals')}}:  {{totalCount}}</span>
      </div>
      <div class="wrapp-orders">
        <div class="wrapp-orders-wrapp">
          <ul class="wrapp-orders-wrapp-list">
            <li v-for="order in orders" :key="order.id" class="wrapp-orders-wrapp-list-item">
              <orderTile :order="order" :inputText="inputText" />
            </li>
            <li v-show="!orders.length">
              <div class="no-orders text-center mt-4">
                {{ $t('search.no-orders-found') }}
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="d-flex justify-content-center">
        <pagination
        v-show="orders.length"
        :total="totalCount"
        :size="pagination.size"
        :start="pagination.start"
        @changePage="changePage" />
      </div>
    </template>
  </div>
</template>

<script>
import Config from 'config'
import Pagination from 'theme/components/Pagination/Pagination'
import OrderTile from 'theme/components/Search/Tiles/OrderTile'

export default {
  name: 'Orders',
  props: {
    searchResponse: {
      type: Array | Object,
      required: true
    },
    inputText: {
      type: String,
      default: () => ''
    }
  },
  data () {
    return {
      pagination: {
        start: 0,
        page: 0,
        size: Config.Theme.searchSuggestions.ordersLimit
      }
    }
  },
  computed: {
    orders () {
      if (this.searchResponse) {
        return this.searchResponse.items
      } else {
        return []
      }
    },
    totalCount () {
      if (this.searchResponse) {
        return this.searchResponse.total_count || 0
      }
    }
  },
  methods: {
    changePage (start) {
      this.pagination.page = Math.ceil(start / this.pagination.size) + 1
      this.pagination.start = start
      this.$emit('changePage', this.pagination)
    }
  },
  components: {
    OrderTile,
    Pagination
  }
}
</script>
